
  import {defineComponent,onMounted} from 'vue'
  export default defineComponent({
    name: 'index',
    setup(props,ctx){
      onMounted(()=>{
        return
      })
      return{}
    }
  })
